import { map } from "lodash";
import Button from "../ui/Button";

export default function StructuringReasoningModal({ onClose, reasoning = [] }) {
  return (
    <div
      id="StructuringReasoningModal"
      className="h-full w-full max-w-[560px] max-h-[560px] rounded-md flex flex-col bg-background border">
      <div
        id="StructuringReasoningModal__header"
        className="flex flex-col gap-1 p-4 border-b">
        <h2 className="text-sm font-medium text-secondary-foreground">
          Reasoning
        </h2>
        <p className="text-xs text-secondary-foreground/60">
          Why the prompt was structured this way — omitted references, empty
          slots, and choices made without a description.
        </p>
      </div>

      <div
        id="StructuringReasoningModal__body"
        className="flex-1 overflow-y-auto p-4">
        <ol className="flex flex-col gap-3 list-none">
          {map(reasoning, (line, index) => (
            <li
              key={index}
              className="flex gap-3 text-xs/5 text-secondary-foreground">
              <span className="shrink-0 w-5 h-5 rounded-full bg-secondary text-secondary-foreground/70 flex items-center justify-center text-[10px]">
                {index + 1}
              </span>
              <span className="flex-1">{line}</span>
            </li>
          ))}
        </ol>
      </div>

      <div
        id="StructuringReasoningModal__footer"
        className="flex justify-end p-2">
        <Button type="secondary" className="min-w-20" onClick={() => onClose()}>
          Close
        </Button>
      </div>
    </div>
  );
}
